import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import SectionWrapper from '../../shared/SectionWrapper';
import {
  SectionTitle,
  SectionPrompt,
  ProjectsGrid,
  ProjectCard,
  ProjectTitle,
  ProjectDescription,
  SkillTags,
  SkillTag,
} from '../styles';

interface ProjectsProps {
  themeName: ThemeType;
}

interface ProjectData {
  name: string;
  description: string;
  tags: string[];
}

const Projects: React.FC<ProjectsProps> = ({ themeName }) => {
  const { t } = useTranslation();
  const items = t('ClassicPage.projects.items', { returnObjects: true }) as ProjectData[];

  if (!Array.isArray(items)) return null;

  return (
    <SectionWrapper id="projects" themeName={themeName}>
      <SectionPrompt $themeName={themeName}>$ ls projects/</SectionPrompt>
      <SectionTitle $themeName={themeName}>{t('ClassicPage.projects.title')}</SectionTitle>
      <ProjectsGrid>
        {items.map((project, i) => (
          <ProjectCard key={i} $themeName={themeName}>
            <ProjectTitle $themeName={themeName}>{project.name}</ProjectTitle>
            <ProjectDescription $themeName={themeName}>{project.description}</ProjectDescription>
            <SkillTags>
              {project.tags.map((tag, j) => (
                <SkillTag key={j} $themeName={themeName}>{tag}</SkillTag>
              ))}
            </SkillTags>
          </ProjectCard>
        ))}
      </ProjectsGrid>
    </SectionWrapper>
  );
};

export default Projects;
